(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allure-launch"] && !Shopify.designMode) return;
  try {
    
function bindAllureLaunch(root){
  if(root.dataset.alBound)return;
  root.dataset.alBound='true';
  const dialog=root.querySelector('.al-launch__sms-dialog');
  const open=root.querySelector('[data-al-sms-open]');
  const close=root.querySelector('[data-al-sms-close]');
  if(dialog&&open&&close){
    open.addEventListener('click',()=>{dialog.showModal()});
    close.addEventListener('click',()=>dialog.close());
    if(root.dataset.smsReady==='true'){
      let seen=false;
      try{seen=sessionStorage.getItem('allure-sms-seen')==='true'}catch{}
      if(!seen)setTimeout(()=>{if(root.isConnected&&!dialog.open){dialog.showModal();try{sessionStorage.setItem('allure-sms-seen','true')}catch{}}},5000);
    }
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close()}});
  }
  const countdown=root.querySelector('[data-al-countdown]');
  if(countdown){
    const target=Date.parse(countdown.dataset.launchAt);
    const timer=countdown.querySelector('[data-al-timer]');
    const ended=countdown.querySelector('[data-al-countdown-ended]');
    let interval;
    const tick=()=>{
      if(!root.isConnected){clearInterval(interval);return}
      if(!Number.isFinite(target)){timer.hidden=true;clearInterval(interval);return}
      const remaining=Math.max(0,Math.floor((target-Date.now())/1000));
      const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
      Object.entries(units).forEach(([unit,value])=>{const node=countdown.querySelector('[data-al-unit="'+unit+'"]');if(node)node.textContent=String(value).padStart(2,'0')});
      if(Date.now()>=target){timer.hidden=true;ended.hidden=false;clearInterval(interval)}
    };
    tick();
    if(Number.isFinite(target)&&Date.now()<target)interval=setInterval(tick,1000);
  }
  const rotation=root.querySelector('[data-al-ld-toggle]');
  if(rotation)rotation.addEventListener('click',()=>{const paused=rotation.classList.toggle('is-paused');rotation.setAttribute('aria-pressed',String(paused));rotation.setAttribute('aria-label',paused?rotation.dataset.playLabel:rotation.dataset.pauseLabel)});
  const password=root.querySelector('.al-launch__access');
  if(password&&password.querySelector('.errors'))password.open=true;
}
document.querySelectorAll('[data-al-launch]').forEach(bindAllureLaunch);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-al-launch]').forEach(bindAllureLaunch)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
